import { Action } from 'redux';
import { IPlaceStatsRow } from '../types/stats';
import { IGeneralStatsRow } from '../types/stats';

export const STATS_GENERAL_REQUEST = 'STATS_GENERAL_REQUEST';
export const STATS_GENERAL_SUCCESS = 'STATS_GENERAL_SUCCESS';
export const STATS_PLACES_REQUEST = 'STATS_PLACES_REQUEST';
export const STATS_PLACES_SUCCESS = 'STATS_PLACES_SUCCESS';
export const STATS_ERROR = 'STATS_ERROR';

export interface IGeneralStatsRequestAction extends Action {
  type: typeof STATS_GENERAL_REQUEST;
  payload?: {
    stepBy?: 'day' | 'week' | 'month';
    from?: Date;
    to?: Date;
  };
}

export interface IGeneralStatsSuccessAction extends Action {
  type: typeof STATS_GENERAL_SUCCESS;
  payload: { rows: IGeneralStatsRow[] };
}

export interface IStatsErrorAction extends Action {
  type: typeof STATS_ERROR;
  message: string;
}

export interface IPlaceStatsRequestAction extends Action {
  type: typeof STATS_PLACES_REQUEST;
}

export interface IPlaceStatsSuccessAction extends Action {
  type: typeof STATS_PLACES_SUCCESS;
  payload: { rows: IPlaceStatsRow[] };
}

export interface IPlacesFetchErrorAction extends Action {
  type: typeof STATS_ERROR;
  message: string;
}

export type IGeneralStatsAction =
  | IGeneralStatsRequestAction
  | IGeneralStatsSuccessAction
  | IStatsErrorAction;

export type IPlaceStatsAction =
  | IPlaceStatsRequestAction
  | IPlaceStatsSuccessAction
  | IPlacesFetchErrorAction;

export function fetchGeneralStatsRequest(
  stepBy?: 'day' | 'week' | 'month',
  from?: Date,
  to?: Date
): IGeneralStatsRequestAction {
  return {
    type: STATS_GENERAL_REQUEST,
    payload: {
      stepBy: stepBy,
      from: from,
      to: to,
    },
  };
}

export function fetchGeneralStatsSuccess(summary: IGeneralStatsRow[]): IGeneralStatsSuccessAction {
  return {
    type: STATS_GENERAL_SUCCESS,
    payload: {
      rows: summary,
    },
  };
}

export function statsError(message: string): IStatsErrorAction {
  return {
    type: STATS_ERROR,
    message,
  };
}

export function fetchPlaceStatsRequest(): IPlaceStatsRequestAction {
  return {
    type: STATS_PLACES_REQUEST,
  };
}

export function fetchPlaceStatsSuccess(places: IPlaceStatsRow[]): IPlaceStatsSuccessAction {
  return {
    type: STATS_PLACES_SUCCESS,
    payload: {
      rows: places,
    },
  };
}



// WEBPACK FOOTER //
// ./src/store/actions/stats.ts